const KIND = 'capsens-prism/workflow-nodes';
const OFFSET = 32;

export function copyPayload(workflow, selection) {
  const steps = workflow.steps.filter((step) => selection.has(step.id));
  const triggers = workflow.triggers.filter((trigger) => selection.has(trigger.id));

  if (steps.length === 0 && triggers.length === 0) return null;

  const kept = new Set(steps.map((step) => step.id));

  return {
    kind: KIND,
    steps: steps.map((step) => ({
      ...structuredClone(step),
      dependsOn: step.dependsOn.filter((id) => kept.has(id)),
    })),
    triggers: triggers.map((trigger) => ({
      ...structuredClone(trigger),
      starts: trigger.starts.filter((id) => kept.has(id)),
    })),
  };
}

export function parsePayload(text) {
  if (!text) return null;

  try {
    const payload = JSON.parse(text);

    if (payload?.kind !== KIND) return null;
    if (!Array.isArray(payload.steps) || !Array.isArray(payload.triggers)) return null;

    return payload;
  } catch {
    return null;
  }
}

export function pasteNodes(workflow, { steps, triggers }, nextId) {
  const remap = new Map([...steps, ...triggers].map((node) => [node.id, nextId()]));
  const taken = new Set(workflow.steps.map((step) => step.key.trim()).filter(Boolean));

  const pastedSteps = steps.map((step) => ({
    ...step,
    id: remap.get(step.id),
    key: freeKey(step.key, taken),
    dependsOn: step.dependsOn.map((id) => remap.get(id)).filter(Boolean),
    ...shifted(step),
  }));

  const pastedTriggers = triggers.map((trigger) => ({
    ...trigger,
    id: remap.get(trigger.id),
    starts: trigger.starts.map((id) => remap.get(id)).filter(Boolean),
    ...shifted(trigger),
  }));

  workflow.steps.push(...pastedSteps);
  workflow.triggers.push(...pastedTriggers);

  return { steps: pastedSteps, triggers: pastedTriggers };
}

function freeKey(key, taken) {
  const base = key.trim();

  if (!base) return base;

  let candidate = base;
  let suffix = 1;

  while (taken.has(candidate)) {
    suffix += 1;
    candidate = `${base}-${suffix}`;
  }

  taken.add(candidate);

  return candidate;
}

function shifted(node) {
  if (node.canvasX === null || node.canvasY === null) return {};

  return { canvasX: node.canvasX + OFFSET, canvasY: node.canvasY + OFFSET };
}
